import { XYZ } from 'domain/types/location/coordinates';

export enum EInteractionType {
  CLICK = 'click',
  HOVER = 'hover',
}

export enum EObjectType {
  BUFFER = 'buffer',
  BUILDING = 'building',
  FLOOR = 'floor',
  PARKING_LOT = 'parkingLot',
  ROOF_SEGMENT = 'roofSegment',
  SEGMENT = 'segment',
  TERRACE_SEGMENT = 'terraceSegment',
  TRANSFORM_CORNER = 'transformCorner',
  TRANSFORM_WALL = 'transformWall',
  UNIT = 'unit',
  VEGETATION = 'vegetation',
  TERRAIN_POINT = 'terrainPoint',
  STATIC_EXISTING_BUILDING = 'staticExistingBuilding',
  EDITABLE_EXISTING_BUILDING = 'editableExistingBuilding',
  MEASUREMENT_POINT = 'measurementPoint',
}

export enum EObjectName {
  ACTIVE_VEGETATION = 'activeVegetation',
  RESTORABLE_VEGETATION = 'restorableVegetation',
  TEMPORARY_VEGETATION = 'temporaryVegetation',
  TERRAIN_SURFACE = 'terrainSurface',
  GROUND_BOTTOM = 'groundBottom',
  PARKING_GARAGE = 'parkingGarage',
  PARKING_GARAGE_DOOR = 'parkingGarageDoor',
  EXISTING_BUILDING = 'existingBuilding',
  OFFSET_TERRAIN = 'offsetTerrain',
  TERRAIN_POINT = 'terrainPoint',
  TERRAIN_WIREFRAME = 'terrainWireframe',
  EXISTING_EDITABLE_BUILDING = 'existingEditableBuilding',
  PARKING_LOT_CORNER = 'parkingLotCorner',
  PARKING_GARAGE_WALL = 'parkingGarageWall',
  MEASUREMENT_POINT = 'measurementPoint',
}

export enum CameraType {
  PERSPECTIVE = 'perspective',
  ORTHOGRAPHIC = 'orthographic',
  FIRST_PERSON = 'firstPerson',
}

export enum TerrainImageType {
  SATELLITE = 'satellite',
  ROADMAP = 'roadmap',
  CADASTRE = 'cadastre',
  WHITE = 'WHITE',
}

export enum EMeasurementPointType {
  BUILDING = 'building',
  TERRAIN_INTERSECTION = 'terrainIntersection',
  TERRAIN = 'terrain',
}

export interface IMeasurementPoint {
  position: XYZ;
  type: EMeasurementPointType;
}
